const gb = {
  code: 'gb',
  name: 'United Kingdom',
  flag: '🇬🇧',
  localTips: [
    'HMRC and bank impersonation calls are widespread — never transfer money based on a cold call.',
    'One-time passcode theft often follows a convincing “fraud team” call.',
  ],
  resources: [
    {
      title: 'Action Fraud',
      description: 'National reporting centre for fraud and cybercrime.',
      url: 'https://www.actionfraud.police.uk/',
    },
    {
      title: 'Ofcom — Scams and fraud',
      description: 'Guidance on scam calls and nuisance communications.',
      url: 'https://www.ofcom.org.uk/phones-and-broadband/scam-calls-and-messages',
    },
  ],
};

export default gb;
